export interface RequirementItem {
    id: number;
    title: string;
    description: string;
}

export const getRequirementsData = (t: any): RequirementItem[] => [
    {
        id: 1,
        title: t('landing.requirements.items.1.title', 'Formación acreditable'),
        description: t('landing.requirements.items.1.desc', 'Contar con formación, certificaciones o experiencia profesional comprobable en el área desde la que ofrecés acompañamiento.')
    },
    {
        id: 2,
        title: t('landing.requirements.items.2.title', 'Identidad profesional clara'),
        description: t('landing.requirements.items.2.desc', 'Presentar información veraz sobre tu recorrido, enfoque, especialidades y forma de trabajo.')
    },
    {
        id: 3,
        title: t('landing.requirements.items.3.title', 'Habilitación cuando corresponda'),
        description: t('landing.requirements.items.3.desc', 'En profesiones reguladas, contar con la habilitación o registro correspondiente según la normativa vigente.')
    },
    {
        id: 4,
        title: t('landing.requirements.items.4.title', 'Compromiso ético'),
        description: t('landing.requirements.items.4.desc', 'Aceptar los términos y condiciones de la plataforma, sus criterios de convivencia profesional y las pautas de comunicación con consultantes.')
    },
    {
        id: 5,
        title: t('landing.requirements.items.5.title', 'Disponibilidad y gestión'),
        description: t('landing.requirements.items.5.desc', 'Mantener actualizada tu agenda, modalidad de atención, datos de contacto y condiciones de reserva.')
    },
    {
        id: 6,
        title: t('landing.requirements.items.6.title', 'Mirada integrativa'),
        description: t('landing.requirements.items.6.desc', 'Compartir una forma de acompañar basada en el respeto, el criterio profesional, el diálogo entre saberes y el cuidado de la persona.')
    }
];
